const formatterValor = new Intl.NumberFormat('pt-BR', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

const formatterQuantidade = new Intl.NumberFormat('pt-BR', {
  maximumFractionDigits: 0,
})

const ehValorNegativo = (valor: number | null | undefined) => Number(valor) < 0

/**
 * Formata valor em BRL com o sinal ANTES do simbolo ("- R$ 4.100,00").
 * O Intl com style currency produz "-R$ 4.100,00", e o filtro global `currency`
 * roda com symbol vazio (os templates prefixam "R$ " na mao), o que geraria
 * "R$ -4.100,00" — sinal no lugar errado.
 */
const formatValorBRL = (valor: number | null | undefined) => {
  const numero = Number(valor) || 0
  const absoluto = formatterValor.format(Math.abs(numero))

  if (ehValorNegativo(numero)) {
    return `- R$ ${absoluto}`
  }

  return `R$ ${absoluto}`
}

// Repasse grande passa de mil itens por profissional: sem separador vira "5291".
const formatQuantidade = (quantidade: number | null | undefined) => formatterQuantidade.format(Number(quantidade) || 0)

export {
  formatValorBRL,
  ehValorNegativo,
  formatQuantidade,
}
